/** Commercial ownership is display data, never an event access grant. */
export type OwnedSubscription = {
  organizationId: string;
  organizationName: string;
  productId: string;
  productName: string;
  subscriptionStatus: "ACTIVE" | "EXPIRED";
  expiresAtEpochMillis: number | null;
  operationalStatus: "READY" | "NOT_READY";
  supportReasonCode: "SERVICE_SETUP_REQUIRED" | null;
};
export type OwnedSubscriptionPage = { items: OwnedSubscription[]; nextCursor: string | null };
export function subscriptionKey(item: OwnedSubscription): string {
  return JSON.stringify([item.organizationId, item.productId]);
}
export function parseOwnedSubscriptionPage(value: unknown): OwnedSubscriptionPage {
  if (!value || typeof value !== "object") throw new Error("Invalid owned subscriptions");
  const page = value as OwnedSubscriptionPage;
  if (!Array.isArray(page.items) || (page.nextCursor !== null && typeof page.nextCursor !== "string") || page.items.some(item =>
    !item || typeof item !== "object" ||
    [item.organizationId, item.organizationName, item.productId, item.productName].some(value => typeof value !== "string" || !value) ||
    !["ACTIVE", "EXPIRED"].includes(item.subscriptionStatus) || !["READY", "NOT_READY"].includes(item.operationalStatus) ||
    (item.expiresAtEpochMillis !== null && (typeof item.expiresAtEpochMillis !== "number" || !Number.isSafeInteger(item.expiresAtEpochMillis))) ||
    (item.operationalStatus === "NOT_READY" ? item.supportReasonCode !== "SERVICE_SETUP_REQUIRED" : item.supportReasonCode !== null)))
    throw new Error("Invalid owned subscriptions");
  return page;
}
